
            const data = {"name":"ic_open_up","data":{"width":"12","height":"8","viewBox":"0 0 12 8","data":"<path pid=\"0\" d=\"M11 7L6 2 1 7\" _stroke=\"#94A4C4\" stroke-width=\"1.667\"/>","originalColors":[{"type":"stroke","color":"#94A4C4"}],"stopColors":[]}}
        
                module.exports = data
                